document.addEventListener('pointerdown', function(e) {
    let el = e.target;
    while (el && el !== document.body) {
        if (el.classList.contains('touch-device')) break;
        el = el.parentElement;
    }
    if (!el || el === document.body) return;

    const ripple = document.createElement('span');
    ripple.className = 'tap-ripple';
    ripple.style.left = e.clientX + 'px';
    ripple.style.top = e.clientY + 'px';

    document.body.appendChild(ripple);

    ripple.addEventListener('animationend', function() {
        ripple.remove();
    }, { once: true });
});
